/**
 * Mirrors the enums in CorrectTrack.Entities.Energy. The values are fixed internal codes stored as
 * ints, so they are safe to hard-code here; the labels come from the translation catalogue.
 */
export const EnergyCommodity = {
    Electricity: 1,
    NaturalGas: 2,
    Water: 3,
    Steam: 4,
    Other: 99,
};

export const COMMODITY_OPTIONS = [
    { value: EnergyCommodity.Electricity, labelKey: 'siteData.commodity.Electricity' },
    { value: EnergyCommodity.NaturalGas, labelKey: 'siteData.commodity.NaturalGas' },
    { value: EnergyCommodity.Water, labelKey: 'siteData.commodity.Water' },
    { value: EnergyCommodity.Steam, labelKey: 'siteData.commodity.Steam' },
    { value: EnergyCommodity.Other, labelKey: 'siteData.commodity.Other' },
];

export const MeterResolution = {
    BilledOnly: 1,
    Interval: 2,
};

export const RESOLUTION_OPTIONS = [
    { value: MeterResolution.BilledOnly, labelKey: 'energySetup.resolution.billedOnly' },
    { value: MeterResolution.Interval, labelKey: 'energySetup.resolution.interval' },
];

export const EnergyDataSource = {
    Manual: 1,
    CsvUpload: 2,
    GreenButtonFile: 3,
    Aggregator: 4,
};

export const DATA_SOURCE_OPTIONS = [
    { value: EnergyDataSource.Manual, labelKey: 'energySetup.dataSource.manual' },
    { value: EnergyDataSource.CsvUpload, labelKey: 'energySetup.dataSource.csvUpload' },
    { value: EnergyDataSource.GreenButtonFile, labelKey: 'energySetup.dataSource.greenButtonFile' },
    { value: EnergyDataSource.Aggregator, labelKey: 'energySetup.dataSource.aggregator' },
];
